// extracted by mini-css-extract-plugin
export default {"card":"xb2HqvV9","imgBox":"rK9otll9","img":"_CnRqENz","text":"eugn82eF","button":"llQ0CLk3"};
    if(module.hot) {
      // 1721070002821
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  